/**
 * Equivalencias explícitas entre los event_id de los archivos y las fichas aprobadas de la guía.
 *
 * Una equivalencia solo se enlaza si se comprueba al cargar los datos: todos los registros de
 * spawns.csv con ese event_id deben llamarse "<mapa>-invasion-<spawnSlug>-<n>".
 * Si no coincide, queda pendiente y no se enlaza. Los event_id que no están en esta tabla
 * (p. ej. "event:devil_square") nunca se unen a una ficha.
 *
 * `approvedPerAppearance` = monstruos por aparición según la información de invasiones aprobada,
 * para que el panel técnico señale diferencias con spawns.csv.
 */
export type EventEquivalence = {
  eventId: string
  spawnSlug: string
  guideEntryId?: string
  approvedPerAppearance?: number
  note?: string
}

export const eventEquivalences: EventEquivalence[] = [
  { eventId: 'invasion:0', spawnSlug: 'death-king', guideEntryId: 'death-king', approvedPerAppearance: 11 },
  { eventId: 'invasion:1', spawnSlug: 'red-dragon', guideEntryId: 'red-dragon', approvedPerAppearance: 3 },
  { eventId: 'invasion:2', spawnSlug: 'golden', guideEntryId: 'golden', approvedPerAppearance: 68, note: 'Ficha "Invasión de Dorados" publicada con autorización del staff (configuración del 08/10/2026).' },
  { eventId: 'invasion:3', spawnSlug: 'white-wizard', guideEntryId: 'white-wizard', approvedPerAppearance: 21 },
  { eventId: 'invasion:4', spawnSlug: 'new-year', guideEntryId: 'new-year', approvedPerAppearance: 10 },
  { eventId: 'invasion:5', spawnSlug: 'rabbits', guideEntryId: 'rabbits', approvedPerAppearance: 10 },
  { eventId: 'invasion:6', spawnSlug: 'summer', guideEntryId: 'summer', approvedPerAppearance: 10 },
]
